import { forwardRef } from 'react';

import type { IconProps } from './types';

const BlockVideo = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 1024 1024"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <path
      d="M992.019 770.737L768 619.894v86.094c0 71.483-57.344 129.378-128 129.378H128c-70.695 0-128-57.935-128-129.378V318.01c0-71.483 57.304-129.378 128-129.378h512c70.656 0 128 57.935 128 129.378v86.252l224.019-150.843c17.605 0 31.98 14.415 31.98 32.295v452.647c.001.059.001.128.001.197 0 17.716-14.317 32.087-32.012 32.177h-.008zM704 318.05c0-35.761-28.672-64.669-64-64.669H128c-35.328 0-64 28.948-64 64.669v387.938c0 35.761 28.672 64.669 64 64.669h512c35.328 0 64-28.908 64-64.669V318.05zm255.999 34.62l-192 129.339v60.14l192 129.339V352.67z"
      fill={color}
    />
  </svg>
));

export default BlockVideo;
